<template>
  <div class="select-wrapper">
    <CustomSelect
      :options="navigationOptions"
      :default="getCurrentRouteName()"
      placeholder="Select section"
      custom-class="navigation-select"
      @selected="navigateTo"
    />
  </div>
</template>
<script>
import CustomSelect from '@/components/inputs/CustomSelect';

export default {
  name: 'CaseMessagesNavigation',
  components: {
    CustomSelect
  },
  data() {
    return {
      navigationOptions: [
        {name: 'Mobile chats', route: 'Case messages mobile chats', id: 'messages_mobile_tab'},
        {name: 'Email', route: 'Case messages email list', id: 'messages_email_tab'},
        {name: 'Media', route: 'Case messages media list', id: 'messages_media_tab'},
        {name: 'Call Logs', route: 'Case messages call logs list', id: 'messages_logs_tab'},
        {name: 'Contacts', route: 'Case messages contacts list', id: 'messages_contacts_tab'},
        {name: 'Apps', route: 'Case messages apps list', id: 'messages_apps_tab'}
      ]
    };
  },
  methods: {
    navigateTo(selectedOption) {
      const option = this.navigationOptions.find(opt => opt.name === selectedOption);
      if (option) {
        this.$router.push({name: option.route});
      }
    },
    getCurrentRouteName() {
      const currentRoute = this.$route.name;
      const option = this.navigationOptions.find(opt => opt.route === currentRoute);
      return option ? option.name : '';
    }
  }
};
</script>
<style scoped lang="scss">
.select-wrapper {
  min-width: 160px;
  max-width: 160px;
  margin-right: 20px;

  :deep(.navigation-select) {
    .selected {
      min-height: 35px;
      border-radius: 79px;
      border: 1px solid var(--case-btn-border-color) !important;
      font-weight: 600;
      transition: all .5s;

      &:hover {
        border-color: var(--accent-color) !important;
      }

      span {
        font-size: 14px;
        line-height: 14px;
        color: var(--secondary-black-color) !important;
      }
    }

    .items div {
      font-size: 14px;
      font-weight: 600;

      &:hover {
        color: var(--accent-color);
      }
    }
  }
}
</style>
